import React, { useState } from "react";
import axios from "axios";

const DataPushed = () => {
    const [type, setType] = useState("");
    const [invoiceNo, setInvoiceNo] = useState("");
    const isCustomer = type === "Customer";
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!type) {
            alert("Please select type");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/erp/data-pushed`,
                {
                    type,
                    invoiceNo
                }
            );

            alert(response.data.message);
        } catch (error) {
            console.error(error);
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.body}>
            <div style={styles.container}>
                <h2 style={styles.heading}>Data Entry</h2>

                <div style={styles.formGroup}>
                    <label>Select Type</label>

                    <select
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                        style={styles.input}
                    >
                        <option value="">-- Select --</option>
                        <option value="Application">
                            Application Invoice
                        </option>
                        <option value="Assessment">
                            Assessment Invoice
                        </option>
                        <option value="Receipt">
                            Receipt Count
                        </option>
                        <option value="Document">
                            Document Review
                        </option>
                        <option value="Aafee">
                            Aafee Invoice
                        </option>
                        <option value="Customer">
                            Customer
                        </option>
                    </select>
                </div>

                <div style={styles.formGroup}>
                    <label>{isCustomer ? "Username" : "Invoice Number"}</label>

                    <input
                        type="text"
                        placeholder={isCustomer ? "Enter username" : "Enter invoice number"}
                        value={invoiceNo}
                        onChange={(e) => setInvoiceNo(e.target.value)}
                        style={styles.input}
                    />
                </div>

                <button
                    onClick={handleSubmit}
                    style={styles.button}
                    disabled={loading}
                >
                    {loading ? "Submitting..." : "Submit"}
                </button>
            </div>
        </div>
    );
};

const styles = {
    body: {
        fontFamily: "Segoe UI",
        background: "#f4f6f9",
        minHeight: "100vh",
        paddingTop: "50px"
    },
    container: {
        width: "400px",
        margin: "auto",
        background: "#fff",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
    },
    heading: {
        textAlign: "center",
        marginBottom: "25px"
    },
    formGroup: {
        marginBottom: "20px"
    },
    input: {
        width: "100%",
        padding: "10px",
        borderRadius: "6px",
        border: "1px solid #ccc"
    },
    button: {
        width: "100%",
        padding: "12px",
        background: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer"
    }
};

export default DataPushed;